module.exports = __webpack_public_path__ + "img/ic_wizard_dot.1dd3969e.svg";